import { render } from "./TanaoroshiProductCodeListPage.vue?vue&type=template&id=1b314f5b"
import script from "./TanaoroshiProductCodeListPage.vue?vue&type=script&lang=js"
export * from "./TanaoroshiProductCodeListPage.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3094357117/src/hybrid_inventory_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__